import { isSSRBuild } from '@/shared/services/Utils';

export const getBaseUrl = (): string =>
    isSSRBuild() ? process.env.BASE_URL : window.location.origin;
